__turbopack_context__.v({
  "tooltipIconWrapper": "index-module__UonnrW__tooltipIconWrapper",
  "wrapper": "index-module__UonnrW__wrapper",
});
